@let urlToExportPage = exportTabUrl();
@let appLogo = appLogo$ | async;
@let brandLogo = brandLogo$ | async;
@let isMachinesTab = routeStore.isMachinesTab();
@let isExportTab = routeStore.isExportRoute();
@let hasAnyLicense = profileStore.hasAnyLicense();
@let loadingLicenses = loadingLicenses$ | async;

<header class="fwe-fixed-header">
  <div class="fwe-navbar">
    <div class="fwe-container fwe-justify-content-space-between">
      <!-- the application logo -->
      <div class="fwe-app-logo-container">
        <div class="app-logo-wrapper">
          @if (appLogo) {
            <img alt="App Logo" [smaWebSrc]="appLogo" />
          }
        </div>
      </div>

      <!-- mobile navigation -->
      @if (hasAnyLicense) {
        <div class="fwe-mobile-flyout fwe-d-block fwe-d-md-none fwe-mr-auto">
          <button
            (click)="mobileNavigationState = 1"
            data-smrtnc-test="navigation--burger"
            class="fwe-burger-button"
          ></button>
        </div>
      }

      @if (hasAnyLicense) {
        <div
          class="fwe-mobile-navlist-container"
          [class.fwe-opened]="mobileNavigationState === 1"
          [class.fwe-closed]="mobileNavigationState === 2"
          (click)="mobileNavigationState = 2"
        >
          <nav class="fwe-mobile-navlist">
            <ng-container
              [ngTemplateOutlet]="navigationList"
              [ngTemplateOutletContext]="{
                urlToExportPage: urlToExportPage ?? 'export',
                isMachinesTab: isMachinesTab,
                isExportTab: isExportTab,
                loading: loadingLicenses,
              }"
            />
          </nav>
        </div>
      }

      <!-- normal navigation -->
      @if (hasAnyLicense) {
        <nav class="fwe-navlist fwe-d-none fwe-d-md-flex">
          <ng-container [ngTemplateOutlet]="navigationList"
                        [ngTemplateOutletContext]="{
              urlToExportPage: urlToExportPage ?? 'export',
              isMachinesTab: isMachinesTab,
              isExportTab: isExportTab,
              loading: loadingLicenses,
            }"
          />
        </nav>
      }

      <!-- The buttons -->
      <div [class.fwe-ml-auto]="!hasAnyLicense" class="fwe-button-container">
        <sma-web-user-pop-over />
      </div>

      <!-- The festo or brand logo -->
      @if (brandLogo) {
        @if (!brandLogo.useDefault) {
          <div
            class="fwe-logo-container"
            [style.marginBottom.px]="brandLogo.containerMarginBottom"
            [style.marginLeft.px]="brandLogo.containerMarginLeft"
          >
            @if (!brandLogo.link) {
              <div
                class="fwe-festo-logo"
                [style.height.px]="brandLogo.height"
                [style.width.px]="brandLogo.width"
                [style.backgroundImage]="brandLogo.backgroundImage"
              ></div>
            } @else {
              <a
                class="fwe-festo-logo"
                [href]="brandLogo.link"
                [style.display]="'block'"
                [style.height.px]="brandLogo.height"
                [style.width.px]="brandLogo.width"
                [style.backgroundImage]="brandLogo.backgroundImage"
              ></a>
            }
          </div>
        } @else {
          <div class="fwe-logo-container">
            <div class="fwe-festo-logo"></div>
          </div>
        }
      }
    </div>
  </div>
</header>

<ng-template
  #navigationList
  let-urlToExportPage="urlToExportPage"
  let-isMachinesTab="isMachinesTab"
  let-isExportTab="isExportTab"
  let-loading="loading"
>
  @if (loading) {
    @for (_ of [1, 2, 3, 4, 5, 6]; track _) {
      <div class="skeleton skeleton-animation"></div>
    }
  } @else {
    <a
      [routerLink]="'home'"
      [routerLinkActive]="'fwe-active'"
      [routerLinkActiveOptions]="{ exact: false }"
      data-smrtnc-test="navigation--home"
    >
      <span>{{ 'NAVIGATION.HOME' | translate }}</span>
    </a>
    <a
      data-smrtnc-test="navigation--machines"
      [routerLink]="['', { outlets: { primary: ['machines'], asset: ['tree'] } }]"
      [class.fwe-active]="isMachinesTab"
      class="fwe-active"
    >
      <span>{{ 'NAVIGATION.MACHINES' | translate }}</span>
    </a>
    <a
      data-smrtnc-test="navigation--all-incidents"
      *smaWebFeatureOn="LicenceFeatureFlag.DIGI_LOG"
      [routerLink]="'incidents'"
      [routerLinkActive]="'fwe-active'"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <span>{{ 'NAVIGATION.ALL_INCIDENTS' | translate }}</span>
    </a>
    <a
      data-smrtnc-test="navigation--spare-parts"
      *smaWebFeatureOn="[LicenceFeatureFlag.DIGI_LOG, LicenceFeatureFlag.SPARE_PARTS]"
      [routerLink]="'spare-parts'"
      [routerLinkActive]="'fwe-active'"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <span>{{ 'NAVIGATION.SPARE_PARTS' | translate }}</span>
    </a>
    <a
      [routerLink]="urlToExportPage"
      [class.fwe-active]="isExportTab"
      data-smrtnc-test="navigation--export"
    >
      <span>{{ 'NAVIGATION.EXPORT' | translate }}</span>
    </a>
    <a
      data-smrtnc-test="navigation--administration"
      *smaWebUserView="UserView.ALL_API"
      [routerLink]="'administration'"
      [routerLinkActive]="'fwe-active'"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <span>{{ 'NAVIGATION.SETTINGS' | translate }}</span>
    </a>
  }
</ng-template>
